export const AGENT_STATUS_RESET_STATE = 'AGENT_STATUS_RESET_STATE';
export const AGENT_STATUS_CURRENT_ITEM = 'AGENT_STATUS_CURRENT_ITEM';

export const AGENT_STATUS_REQUEST_LOADING = 'AGENT_STATUS_REQUEST_LOADING';
export const AGENT_STATUS_REQUEST_SUCCESS = 'AGENT_STATUS_REQUEST_SUCCESS';
export const AGENT_STATUS_REQUEST_FAILED = 'AGENT_STATUS_REQUEST_FAILED';

export const AGENT_STATUS_CURRENT_ACTION = 'AGENT_STATUS_CURRENT_ACTION';
export const AGENT_STATUS_RESET_ACTION = 'AGENT_STATUS_RESET_ACTION';